export default __webpack_public_path__ + "static/media/stree_in_the_workplace.39cc952e.png";